// Admin 左侧导航(替换 AdminTopNav)
// 跟 packages/web/src/components/Sidebar.tsx 共用 globals.css 里的 .sidebar 样式
import { Link, NavLink, useNavigate } from 'react-router-dom'
import { useAuthStore } from '../store/auth.js'
import { logout } from '../api/admin.js'
import { FEATURES } from '../config/features.js'

export function AdminSidebar(): JSX.Element {
  const { user } = useAuthStore()
  const navigate = useNavigate()

  async function handleLogout(): Promise<void> {
    await logout()
    useAuthStore.getState().reset()
    navigate('/login')
  }

  const initial = (user?.display_name ?? user?.email ?? '?').slice(0, 1).toUpperCase()

  return (
    <aside className="sidebar">
      <Link to="/stats" className="sidebar-logo">
        <img className="mark" src="/logo.svg" alt="" width="28" height="28" />
        <div className="name">薇影管理</div>
      </Link>

      <nav className="sidebar-nav">
        <NavLink to="/stats" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}>
          <span className="ico">📊</span>
          <span>大盘</span>
        </NavLink>
        <NavLink to="/users" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}>
          <span className="ico">👥</span>
          <span>用户</span>
        </NavLink>
        {FEATURES.payment && (
          <NavLink to="/orders" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}>
            <span className="ico">💰</span>
            <span>订单</span>
          </NavLink>
        )}
        {FEATURES.billingConfig && (
          <>
            <NavLink to="/billing/recharge" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}>
              <span className="ico">💎</span>
              <span>充值套餐</span>
            </NavLink>
            <NavLink to="/billing/membership" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}>
              <span className="ico">⭐</span>
              <span>订阅档位</span>
            </NavLink>
          </>
        )}
        <NavLink to="/tasks" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}>
          <span className="ico">⚙</span>
          <span>任务</span>
        </NavLink>
        {FEATURES.contentOps && (
          <>
            {FEATURES.presets && (
              <NavLink to="/presets" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}>
                <span className="ico">📝</span>
                <span>预设</span>
              </NavLink>
            )}
            <NavLink to="/prompt-specs" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}>
              <span className="ico">📖</span>
              <span>规范</span>
            </NavLink>
            <NavLink to="/manuals" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}>
              <span className="ico">📚</span>
              <span>手册</span>
            </NavLink>
            <NavLink to="/candidates" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}>
              <span className="ico">🗂</span>
              <span>候选</span>
            </NavLink>
          </>
        )}
        <NavLink to="/creative-perf" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}>
          <span className="ico">📈</span>
          <span>投放回流</span>
        </NavLink>
        <NavLink to="/topic-config" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}>
          <span className="ico">🔎</span>
          <span>选题分析</span>
        </NavLink>
        <NavLink to="/feedback" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}>
          <span className="ico">📮</span>
          <span>意见反馈</span>
        </NavLink>
        <NavLink to="/audit" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}>
          <span className="ico">📜</span>
          <span>审计</span>
        </NavLink>
        <NavLink to="/config" className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}>
          <span className="ico">🔧</span>
          <span>配置</span>
        </NavLink>
      </nav>

      {FEATURES.transferPay && (
        <>
          <div className="sidebar-section">支付</div>
          <NavLink
            to="/payments/reconcile"
            className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}
          >
            <span className="ico">✓</span>
            <span>对账</span>
          </NavLink>
          <NavLink
            to="/payments/orphans"
            className={({ isActive }) => `sidebar-link ${isActive ? 'active' : ''}`}
          >
            <span className="ico">⚠</span>
            <span>孤儿单</span>
          </NavLink>
        </>
      )}

      <div className="sidebar-bottom">
        <div className="sidebar-account" style={{ cursor: 'default' }}>
          <div className="avatar" style={{ background: 'linear-gradient(135deg, #475569, #1f2937)' }}>
            {initial}
          </div>
          <div className="meta">
            <div className="name">{user?.display_name ?? user?.email ?? '未登录'}</div>
            <div className="credits" style={{ color: 'var(--text-muted)' }}>管理员</div>
          </div>
          <span
            style={{ color: 'var(--text-muted)', cursor: 'pointer', padding: '0 4px' }}
            onClick={handleLogout}
            title="退出登录"
          >
            ⎋
          </span>
        </div>
      </div>
    </aside>
  )
}
